import React, { useEffect, useRef } from 'react';

const Hero = () => {
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.2 }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="w-full max-w-[1200px] px-4 py-12 md:py-20 md:px-10">
      <div className="@container">
        <div className="flex flex-col-reverse gap-10 md:gap-16 items-center md:flex-row">
          <div className="flex flex-col gap-6 md:w-1/2 items-start">
            <div className="flex flex-col gap-4 text-left">
              <h1 className="text-white text-5xl md:text-6xl font-black leading-tight tracking-[-0.033em]">
                Understand your UPI spending. <span className="text-primary">Privately.</span>
              </h1>
              <h2 className="text-text-muted text-lg font-normal leading-relaxed max-w-[500px]">
                Import UPI transaction statements and get instant insights on your spending - without storing a single byte of your data!
              </h2>
            </div>
          </div>
          <div className="w-full md:w-1/2 flex justify-center relative">
            <div className="absolute inset-0 bg-primary/20 blur-[100px] rounded-full scale-75"></div>
            <div ref={imageRef} className="relative w-full max-w-[340px] z-10 opacity-0 translate-y-8 transition-all duration-700 ease-out">
              <img 
                src="/web-dashboard-new.png" 
                alt="Mobile app dashboard showing expense tracking with ₹12,450 total spent, Quick Actions, Recent Merchants, and Recent Activity" 
                className="w-full h-auto rounded-[2.5rem] shadow-2xl shadow-primary/20"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
